<template>
  <div class="d-flex align-center ga-2">
    <CustomSwitchWrapper
      class="mb-2"
      data-test-id="group-quorum-control-toggle"
      :disabled="createStore.hasActiveGroupQuorum"
      :initial-value="Boolean(quorumControl)"
      :label="String(i18n.t('labels.group_quorum_control'))"
      label-class="drawer-subhead"
      :switch-id="i18n.t('labels.group_quorum_control')"
      @value-changed="toggleQuorumControl"
    >
      <template #label-append>
        <span class="ml-1">
          <v-menu
            location="left top"
            max-width="300"
            open-on-click
            open-on-hover
          >
            <template #activator="{ props: ActivatorProps }">
              <v-icon
                v-bind="ActivatorProps"
                aria-label="Group quorum hint"
                class="icon"
                color="grey"
                size="13"
              >
                far fa-circle-info
              </v-icon>
            </template>
            <v-card class="pa-3" flat>
              <v-card-text class="pa-0">
                {{ i18n.t('texts.quorum_hint') }}
              </v-card-text>
            </v-card>
          </v-menu>
        </span>
      </template>
    </CustomSwitchWrapper>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useQuorumControlSetting } from '@/composables/useQuorumControlSetting';
import { useCreateStore } from '@/stores/create.ts';
import CustomSwitchWrapper from '@/components/inputs/CustomSwitchWrapper.vue';

const i18n = useI18n();
const createStore = useCreateStore();
const { quorumControl, toggleQuorumControl } = useQuorumControlSetting();
</script>
